// todo moving forward we'll have to use a proper library for dealing with money
// todo https://sarahdayan.github.io/dinero.js/

export const capitalize = function(value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const underscoresToSpaces = function(value) {
  return value ? value.replace(/_/g, ' ') : '';
};

export const currency = function(value, currency = 'CAD') {
  return Number(value).toLocaleString('en-CA', {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
    useGrouping: true,
    minimumIntegerDigits: 1,
  });
};

export const percent = function(value) {
  return Number(value).toLocaleString('en-CA', {
    style: 'percent',
    useGrouping: false,
    minimumIntegerDigits: 1,
    minimumFractionDigits: 2,
  });
};
